import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthFongesoftGuard } from './modules/auth-overriden/_services/auth-fongesoft.guard';
import { AuthGuard } from './modules/auth-overriden/_services/auth.guard';
// import { AuthGuard } from './modules/auth-overriden/_services/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth-overriden/auth.module').then((m) => m.AuthModule),
  },

  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'fongesoft',
    canActivate:[AuthFongesoftGuard],
    loadChildren: () =>
      import('./pages/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'open',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./open/open.module').then((m) => m.OpenModule),
  },
  { path: '**', redirectTo: 'errors/404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
